// extracted by mini-css-extract-plugin
export default {"contenedor":"SelectorRival_contenedor__SIMvl","titulo":"SelectorRival_titulo__NMTDv","botonBuscar":"SelectorRival_botonBuscar__F6Kjz"};